import styled from "styled-components";

export default styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  .MuiCircularProgress-circle {
    stroke: grey;
  }
`;
